/**
 * glør Verfügbare Werte — blendet in der Varianten-Auswahl NUR die Options-Werte
 * aus, deren Kombination gar nicht als Variante existiert (z. B. eine Farbe, die
 * es bei der gewählten Größe nicht gibt). AUSVERKAUFTE, aber existierende
 * Varianten bleiben sichtbar und werden nur leicht ausgegraut.
 *
 * Horizon markiert „existiert nicht" und „ausverkauft" beide gleich
 * (data-option-available=false). Deshalb lesen wir die echte Varianten-Matrix
 * über /products/{handle}.js und unterscheiden selbst. Kein Core-Eingriff.
 */
(async () => {
  const picker = document.querySelector('variant-picker[data-product-handle], variant-picker[data-product-url]');
  if (!(picker instanceof HTMLElement)) return;

  const marker = document.querySelector('.glr-hide-unavailable');
  const targets = (marker && marker.dataset.options ? marker.dataset.options : '')
    .split(',').map((x) => x.trim().toLowerCase()).filter(Boolean);

  const fieldsetName = (fs) => {
    const r = fs.querySelector('input[data-option-name]');
    return r instanceof HTMLInputElement ? (r.dataset.optionName || '').trim().toLowerCase() : '';
  };

  /** @type {Map<string, boolean>} key = optionwerte.join('||') -> available (auf Lager) */
  const exists = new Map();

  // 1) Bevorzugt: serverseitig eingebettete Matrix (kein Fetch -> kein Aufblitzen).
  const matrixEl = document.querySelector('[data-glr-variant-matrix]');
  if (matrixEl && matrixEl.textContent) {
    try {
      for (const v of JSON.parse(matrixEl.textContent)) {
        const key = (v.o || []).map((o) => String(o).trim().toLowerCase()).join('||');
        exists.set(key, v.a === true);
      }
    } catch (e) { /* faellt unten auf Fetch zurueck */ }
  }

  // 2) Fallback: /products/{handle}.js (nur falls keine Matrix da ist).
  if (exists.size === 0) {
    const base = (picker.dataset.productUrl || '').split('?')[0];
    const handle = picker.dataset.productHandle;
    const url = base ? `${base}.js` : (handle ? `/products/${handle}.js` : null);
    if (!url) return;
    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      const product = await res.json();
      for (const v of product.variants || []) {
        const key = (v.options || []).map((o) => String(o).trim().toLowerCase()).join('||');
        exists.set(key, v.available === true);
      }
    } catch (e) {
      return;
    }
  }
  if (exists.size === 0) return;

  const fieldsets = () => Array.from(picker.querySelectorAll('fieldset'));

  /** aktuell gewählter Wert je Fieldset (in Options-Reihenfolge) */
  const currentValues = (fsList) =>
    fsList.map((fs) => {
      const r = fs.querySelector('input[type="radio"]:checked');
      return r instanceof HTMLInputElement ? r.value.trim().toLowerCase() : '';
    });

  let applying = false;

  const apply = () => {
    applying = true;
    const fsList = fieldsets();
    const cur = currentValues(fsList);

    fsList.forEach((fs, fi) => {
      const isTarget = targets.length === 0 || targets.includes(fieldsetName(fs));
      fs.querySelectorAll('input[type="radio"]').forEach((radio) => {
        if (!(radio instanceof HTMLInputElement)) return;
        const label = radio.closest('label');
        if (!label) return;

        if (!isTarget) {
          // Option nicht im Ziel (z. B. Größe) -> immer alle Werte zeigen
          label.style.display = '';
          label.style.opacity = '';
          return;
        }

        const combo = cur.slice();
        combo[fi] = radio.value.trim().toLowerCase();
        const key = combo.join('||');

        if (!exists.has(key)) {
          // Kombination existiert nicht als Variante -> ausblenden
          label.style.display = 'none';
          label.style.opacity = '';
        } else if (exists.get(key) === false) {
          // existiert, aber ausverkauft -> sichtbar, leicht ausgegraut
          label.style.display = '';
          label.style.opacity = '0.4';
        } else {
          label.style.display = '';
          label.style.opacity = '';
        }
      });
    });

    requestAnimationFrame(() => { applying = false; });
  };

  apply();

  // Nach jedem Variantenwechsel rendert der native Picker neu -> erneut anwenden.
  const obs = new MutationObserver(() => { if (!applying) apply(); });
  obs.observe(picker, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-option-available', 'checked'] });
})();
